import {
	HashRouter as Router,
	Route,
	Routes,
	useNavigate,
	useSearchParams,
} from "react-router-dom";
import "./styles/App.scss";
import React, { useState, useEffect, useMemo } from "react";
import Cookies from "js-cookie";
import { doc, onSnapshot } from "firebase/firestore";
import { UserContext } from "./components/User";
import db from "./firebase";
import Video from "./components/Video";
import Downloader from "./components/Downloader";
import Intro from "./components/Intro";
import Board from "./components/Board";
import ProfilePage from "./components/ProfilePage";
import Dashboard from "./components/DashBoard";
import MemoryGame from "./components/MemoryGame";
import MemoryGame2 from "./components/MemoryGame2";
// import FoundMatch from "./components/FoundMatch"
import ProtectedRoute from "./components/ProtectedRoute";
import FullDashboard from "./components/FullDashboard";
import SignUp from "./components/SignUp";
import Quiz from "./components/Quiz";
import Qr from "./components/Qr";
import adapter from "webrtc-adapter";
import Activities from "./components/Activities";
import Packets from "./components/Packets";
import Rewards from "./components/Rewards";
import Avatar from "./components/Avatar";
import { ReactComponent as LagoonLogoLoader } from "./assets/logo.svg";
import PhotoBooth from "./components/PhotoBooth";
import Admin from "./components/Admin";
import Bio from "./components/Bio";
import Twilio from "./components/Twilio";
import SendMessage from "./components/sendMessage";
import SignUp1 from "./components/SignUp1";

function App() {
	const isCookie = Cookies.get().id;
	const [user, setUser] = useState({});
	const providerValue = useMemo(() => ({ user, setUser }), [user, setUser]);
	// const providerValue1 = useMemo(() => ({ fire, setFire }), [fire, setFire]);
	const [bgColor, setBgColor] = useState("$dark-purple");

	// user state could potentially only be local throughout components, needs to be global.
	useEffect(() => {
		console.log("useeffect appjs");
		if (isCookie !== undefined) {
			const unsub = onSnapshot(doc(db, "users", isCookie), (doc) => {
				console.log("I am snapshot listener in appjs");
				setUser(doc.data());
			});
			return () => unsub();
		}
	}, [isCookie]);

	return (
		<>
			<div>
				<div className="loader">
					<LagoonLogoLoader className="lagoon-loader-logo" />
				</div>
				<Router basename={process.env.PUBLIC_URL}>
					<UserContext.Provider value={providerValue}>
						<Routes>
							<Route path="/signup" element={<SignUp />} />
							<Route path="/signup1" element={<SignUp1 />} />
							<Route path="/t" element={<Twilio />} />
							<Route path="/intro" element={<Intro />} />
							<Route path="/qr" element={<Qr />} />
							<Route path="/sendM" element={<SendMessage />} />
							<Route
								path=":packet_id/ar/:id"
								element={
									<ProtectedRoute>
										<PhotoBooth />
									</ProtectedRoute>
								}
							/>
							<Route
								path=":packet_id/mint/:id"
								element={
									<ProtectedRoute>
										<Avatar />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/"
								element={
									<ProtectedRoute>
										<Dashboard />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/profile"
								element={
									<ProtectedRoute>
										<ProfilePage />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/admin"
								element={
									<ProtectedRoute>
										<Admin />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/activities"
								element={
									<ProtectedRoute>
										<Packets />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/rewards"
								element={
									<ProtectedRoute>
										<Rewards />
									</ProtectedRoute>
								}
							/>
							<Route
								path=":packet_id/video/:id/"
								element={
									<ProtectedRoute>
										<Video />
									</ProtectedRoute>
								}
							/>
							<Route
								path=":packet_id/bio/:id/"
								element={
									<ProtectedRoute>
										<Bio />
									</ProtectedRoute>
								}
							/>
							<Route
								path=":packet_id/download/:id"
								element={
									<ProtectedRoute>
										<Downloader />
									</ProtectedRoute>
								}
							/>
							<Route
								path=":packet_id/quiz/:id"
								element={
									<ProtectedRoute>
										<Quiz animate={true} />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/board"
								element={
									<ProtectedRoute>
										<Board />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/fulldashboard"
								element={
									<ProtectedRoute>
										<FullDashboard />
									</ProtectedRoute>
								}
							/>
							<Route
								path=":packet_id/memory/:id"
								element={
									<ProtectedRoute>
										<MemoryGame />
									</ProtectedRoute>
								}
							/>
							{/* <Route
							path="/match"
							element={
								<ProtectedRoute>
									<FoundMatch />
								</ProtectedRoute>
							}
						/> */}
						</Routes>
					</UserContext.Provider>
				</Router>
			</div>
		</>
	);
}

export default App;
